import React from 'react';
import PropTypes from 'prop-types';

import { Caption, CaptionImage, CaptionFooter } from '../Caption';
import CaptionHeader from '../Caption/CaptionHeader';
import KeyToProfession from '../../transforms/KeyToProfession';

class ArtistCard extends React.PureComponent {
  getImage() {
    const { artist } = this.props;

    if (artist.images) {
      return artist.images[0].url;
    }
    return '';
  }

  render() {
    const { artist, animate } = this.props;

    return (
      <Caption animate={animate}>
        <CaptionImage
          url={this.getImage()}
        />

        <div className="caption detail">
          <CaptionHeader
            title={`${artist.name} ${artist.lastname}`}
            titleUrl={`/artist/${artist.slug}`}
            subtitle={`${KeyToProfession(artist.profession)} ${artist.specialty && `- ${artist.specialty}`}`}
          >
            <p className="mt-10 mb-0 italic">
              {this.props.gender && <span className="capitalize">{this.props.gender}</span>}
              {(this.props.year && this.props.year !== 0) ? ` - ${this.props.year}` : ''}
              {this.props.saleOrRent && ` - ${this.renderSaleOrRent()}`}
            </p>
          </CaptionHeader>

          <div className="artist-description">
            {artist.biography}
          </div>

          <CaptionFooter>
            <div className="artist-footer__location">
              <i className="fa fa-map-marker pr-5" />
              {artist.nationality}
            </div>
            {/* <div>
              <Ago time={artist.createdAt} />
              <div className="clearfix" />
            </div> */}
          </CaptionFooter>
        </div>
      </Caption>
    );
  }
}

ArtistCard.propTypes = {
  animate: PropTypes.string,
  artist: PropTypes.object,
};

ArtistCard.defaultProps = {
  animate: '',
  artist: {},
};

export default ArtistCard;



// WEBPACK FOOTER //
// ./src/components/Cards/ArtistCard.js